<template>
  <div class="content" style="display: flex; justify-content: center">
    <!-- <span class="fx__text_middle">修改登录密码</span> -->
    <div style="display: flex; flex-direction: column" class="flex_per">
      <Row style="flex: 0.1"></Row>
      <Row>
        <i-col span="24">
          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" label-position="right" :label-width="100">
            <FormItem label="输入旧密码" prop="oldpwd">
              <Input v-model="formValidate.oldpwd" type="password" />
            </FormItem>
            <FormItem label="输入新密码" prop="newpwd">
              <Input v-model="formValidate.newpwd" type="password" />
            </FormItem>
            <FormItem label="重复新密码" prop="passwdCheck">
              <Input v-model="formValidate.passwdCheck" type="password" />
            </FormItem>
            <FormItem>
              <div style="display: flex; justify-content: space-between; width: 100%">
                <Button type="primary" @click="save" style="flex: 1; margin-right: 5px">提交</Button>
                <Button type="primary" @click="reset" style="flex: 1; margin-left: 5px">重置</Button>
              </div>
            </FormItem>
          </Form>
        </i-col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let { verification_rules, error_prompt, verification_func } = this.$app.Cfg.core.account_security
    const PWDRegExp = new RegExp(verification_rules)
    const validatePass = async (rele, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"))
      } else {
        let hook = null
        try {
          hook = await fxImport("./web/config/core/hook.config.js")
        } catch (error) {}

        if (hook && hook.verificationUserPwd) {
          try {
            await hook.verificationUserPwd(value)
          } catch (error) {
            callback(error)
          }
        } else if (!PWDRegExp.test(value)) {
          callback(new Error(error_prompt))
        }

        if (this.formValidate.passwdCheck !== "") {
          // 对第二个密码框单独验证
          this.$refs.formValidate.validateField("passwdCheck")
        }
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"))
      } else if (value !== this.formValidate.newpwd) {
        callback(new Error("两次密码不一样"))
      } else {
        callback()
      }
    }
    return {
      formValidate: {
        oldpwd: "",
        newpwd: "",
        passwdCheck: "",
      },
      ruleValidate: {
        oldpwd: [{ required: true, message: "旧密码不能为空", trigger: "blur" }],
        newpwd: [{ required: true, validator: validatePass, trigger: "blur" }],
        passwdCheck: [{ required: true, validator: validatePassCheck, trigger: "blur" }],
      },
    }
  },
  methods: {
    save() {
      let enctyptLoginPWD = window.fx_packaging_loginpwd
      let _this = this
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          let { oldpwd, newpwd } = _this.formValidate
          let _form = {}
          if (_this.$app.ProjSetting.isCryptoLoginPWD) {
            oldpwd = enctyptLoginPWD(oldpwd)
            newpwd = enctyptLoginPWD(newpwd)
          }
          _form["oldpwd"] = oldpwd
          _form["newpwd"] = newpwd
          _this.$curl.post("/api/core/personal/modifypwd", _form).then(() => {
            _this.$Message.info("保存成功")
            this.$refs.formValidate.resetFields()
          })
        }
      })
    },
    reset() {
      this.$refs.formValidate.resetFields()
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  position: relative;
  height: calc(100%);
  padding: 10px;
}

@media screen and (max-width: 1920px) {
  .flex_per {
    flex: 0.5;
  }
}
@media screen and (max-width: 768px) {
  .flex_per {
    flex: 1;
  }
}
</style>
